import React from 'react'
import PropTypes from 'prop-types'
import {
  POOL_STATUS_ALL,
  POOL_STATUS_INACTIVE,
  POOL_STATUS_OFFLINE,
  POOL_STATUS_ONLINE
} from '../../../../constants/poolStatuses'

class IsOffline extends React.Component {

  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  onChange(e) {
    this.props.onChange(e.target.value)
  }

  render() {
    return <select className="form-control-sm" value={this.props.value || POOL_STATUS_ALL} onChange={this.onChange}>
      <option value={POOL_STATUS_ALL}>All</option>
      <option value={POOL_STATUS_ONLINE}>Online</option>
      <option value={POOL_STATUS_OFFLINE}>Offline</option>
      <option value={POOL_STATUS_INACTIVE}>Inactive</option>
    </select>
  }
}

export default IsOffline

IsOffline.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/pools/index/isOffline/index.js